import { render, staticRenderFns } from "./SaleTypeEditTexts.vue?vue&type=template&id=e0949644"
import script from "./SaleTypeEditTexts.vue?vue&type=script&lang=ts"
export * from "./SaleTypeEditTexts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0949644')) {
      api.createRecord('e0949644', component.options)
    } else {
      api.reload('e0949644', component.options)
    }
    module.hot.accept("./SaleTypeEditTexts.vue?vue&type=template&id=e0949644", function () {
      api.rerender('e0949644', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-sales/SaleTypeEditTexts.vue"
export default component.exports